import React, { useRef, useState } from 'react';
import InfiniteScroll from "react-infinite-scroll-component";
import { VideoPlayProvider } from './VideoPlayProvider';

import useParentWidth from '../../../hooks/useParentWidth';
import AdvancedMediaViewer from "../AdvancedMediaViewer/AdvancedMediaViewer";
import InfiniteScrollLoading from '../InfiniteScrollLoading/InfiniteScrollLoading';
import NoContent from '../NoContent/NoContent';
import FeedPageVirtualized from './FeedPageVirtualized';

const FeedVirtualized = ({
        infiniteQuery,
        emptyDataContent,
    }) => {
    const parentRef = useRef(null);
    const [toggleAMV, setToggleAMV] = useState(false);
    const parentWidth = useParentWidth(parentRef);

    const {
        isSuccess, 
        isFetched, 
        isError, 
        error, 
        data, 
        fetchNextPage, 
        hasNextPage
    } = infiniteQuery;

    const listPages = data?.pages || [];
    const emptyData = (!listPages.length || !listPages[0]?.data?.length);
    let medias = [];
    if (data?.pages) {
        for (let page of data.pages) {
            let mediasFromPublications = page.data.filter(item => (item.publicationType === "Media" || item.kind === "gallery" || item.kind === "video"));
            medias = [...medias, ...mediasFromPublications];
        }
    }

    return (
        <div ref={parentRef} >
            {toggleAMV && <AdvancedMediaViewer
                medias={medias}
                initialMediaId={toggleAMV}
                handleClose={()=>setToggleAMV(false)}
            />}
            {!isFetched && (
                <InfiniteScrollLoading/>
            )}
            {isSuccess && isFetched && (
                <VideoPlayProvider>
                    <InfiniteScroll
                        dataLength={listPages.length}
                        next={() => fetchNextPage()}
                        hasMore={hasNextPage}
                        loader={<InfiniteScrollLoading/>}
                        style={{overflow: 'hidden'}}
                        endMessage={
                            <NoContent>
                                {
                                    emptyData 
                                    ? emptyDataContent
                                    : '🎉 Tout est vu, revenez bientôt !'
                                }
                            </NoContent>
                        }
                    >
                        {listPages.map((page, index) => <FeedPageVirtualized items={page.data} key={index} parentWidth={parentWidth} handleOpenMediaViewer={setToggleAMV}/>)}
                    </InfiniteScroll>
                </VideoPlayProvider>
            )}
            {!isFetched && isError && ([400, 500].includes(error.statusCode)) && (
                <NoContent>Oups, Impossible de charger le fil.</NoContent>
            )}
        </div>
    );
}

export default React.memo(FeedVirtualized);